import {
  authedFetch,
  UnauthorizedError,
} from '@apis/auth';

async function parseStandardErrors(res: Response): Promise<never> {
  const body = await res.json().catch(() => null) as Record<string, unknown> | null;

  if (res.status === 401) throw new UnauthorizedError();

  const errorMsg = (body?.error as Record<string, unknown> | undefined)?.message as string | undefined;
  throw new Error(`request failed: ${res.status} ${errorMsg ?? ''}`);
}

export async function fetchReadState(
  siteId: string,
  signal?: AbortSignal,
): Promise<{ read: Record<string, number> }> {
  const res = await authedFetch(
    `/api/sites/${encodeURIComponent(siteId)}/read-state`,
    { signal },
  );
  if (res.ok) return (await res.json()) as { read: Record<string, number> };
  return parseStandardErrors(res);
}

export async function patchReadState(
  siteId: string,
  read: Record<string, number>,
): Promise<{ read: Record<string, number> }> {
  const res = await authedFetch(
    `/api/sites/${encodeURIComponent(siteId)}/read-state`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ read }),
    },
  );
  if (res.ok) return (await res.json()) as { read: Record<string, number> };
  return parseStandardErrors(res);
}
